'use client';

import * as LabelPrimitive from '@radix-ui/react-label';
import { cva } from 'class-variance-authority';
import type * as React from 'react';

import { cn } from '@/utils/ui-utils';

const labelVariants = cva('font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70');

const Label = ({ className, ...props }: React.ComponentProps<typeof LabelPrimitive.Root>) => (
  <LabelPrimitive.Root
    className={cn(labelVariants(), className)}
    {...props}
  />
);
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
